<template>
  <div class="tw:bg-blue-800">
    <ContainerLayout class="tw:py-11 tw:flex tw:gap-x-8">
      <div class="tw:flex tw:flex-col tw:w-full tw:md:flex-row tw:space-between tw:items-start tw:md:items-center">
        <div class="tw:text-white tw:w-full tw:flex tw:flex-col tw:gap-y-1 tw:mb-6 tw:md:mb-0">
          <h1 class="tw:text-white tw:text-[32px] tw:leading-[40px] tw:font-bold">
            {{ $t('plus_support_header') }}
          </h1>
          <p class="tw:md:max-w-[80%]" v-html="$t('plus_support_subtext')" />
        </div>
        <GhostLinkButton
          @click="logEvent"
          rel="noopener noreferrer"
          href="https://outlook.office365.com/book/TrivagoBussinessPlusHelpmeupgradetoPlus@trvoffice.onmicrosoft.com/"
          target="_blank"
          dataTestId="plus-insights-book-a-call-button"
        >
          <div class="tw:flex tw:gap-x-1 tw:items-center tw:text-nowrap">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20 8H4V7C4 6.449 4.449 6 5 6H19C19.551 6 20 6.449 20 7V8ZM20 18C20 18.551 19.551 19 19 19H5C4.449 19 4 18.551 4 18V9H20V18ZM19 5H18C18 4.448 17.552 4 17 4C16.448 4 16 4.448 16 5H8C8 4.448 7.552 4 7 4C6.448 4 6 4.448 6 5H5C3.896 5 3 5.896 3 7V18C3 19.104 3.896 20 5 20H19C20.104 20 21 19.104 21 18V7C21 5.896 20.104 5 19 5Z"
                fill="currentColor"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9 12.5C9 13.328 8.328 14 7.5 14C6.672 14 6 13.328 6 12.5C6 11.672 6.672 11 7.5 11C8.328 11 9 11.672 9 12.5Z"
                fill="currentColor"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.0001 8H4.00012V7C4.00012 6.449 4.44912 6 5.00012 6H19.0001C19.5511 6 20.0001 6.449 20.0001 7V8ZM20.0001 18C20.0001 18.551 19.5511 19 19.0001 19H5.00012C4.44912 19 4.00012 18.551 4.00012 18V9H20.0001V18ZM19.0001 5H18.0001C18.0001 4.448 17.5521 4 17.0001 4C16.4481 4 16.0001 4.448 16.0001 5H8.00012C8.00012 4.448 7.55212 4 7.00012 4C6.44812 4 6.00012 4.448 6.00012 5H5.00012C3.89612 5 3.00012 5.896 3.00012 7V18C3.00012 19.104 3.89612 20 5.00012 20H19.0001C20.1041 20 21.0001 19.104 21.0001 18V7C21.0001 5.896 20.1041 5 19.0001 5Z"
                fill="currentColor"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.50012 14C8.32812 14 9.00012 13.329 9.00012 12.5C9.00012 11.671 8.32812 11 7.50012 11C6.67112 11 6.00012 11.671 6.00012 12.5C6.00012 13.329 6.67112 14 7.50012 14Z"
                fill="currentColor"
              />
            </svg>
            {{ $t('plus_support_cta') }}
          </div>
        </GhostLinkButton>
      </div>
    </ContainerLayout>
  </div>
</template>
<script setup>
import GhostLinkButton from '@/components/base/buttons/GhostLinkButton.vue'
import { useStudioPlusCampaign } from '@/components/payment/queries'
import ContainerLayout from '@/layouts/ContainerLayout.vue'

import { selectedAccommodationId } from '@/layouts/queries'

import appAnalytics from '@/utils/tracking'

const { isCancelledSubscription } = useStudioPlusCampaign(selectedAccommodationId)

const logEvent = () => {
  appAnalytics.track(appAnalytics.events.SP_PLUS_INSIGHTS_CONSULTATION_CTA_CLICKED, {
    item_id: selectedAccommodationId.value,
    subscription_status: isCancelledSubscription.value ? 'cancelled' : 'active',
  })
}
</script>
